import { Fragment, FC, ReactElement, ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { sessionTokenSelector } from 'store/selectors/userSelectors/sessionTokenSelector';

export const AuthGuard: FC<{ children: ReactNode }> = ({ children }): ReactElement | null => {
  const sessionToken = useSelector(sessionTokenSelector);
  if (!sessionToken) return null;
  return <Fragment>{children}</Fragment>;
};
